import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
  Select,
  Grid,
  DialogTitle,
  Divider,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import CustomDialog from "components/reusables/CustomDialog";
import EditIcon from "@mui/icons-material/Edit";
import countryData from "utils/countriesData.json";

const defaultAddress = {
  streetArea: "",
  pincode: "",
  countryId: "",
  countryName: "",
  stateId: "",
  stateName: "",
  cityId: "",
  cityName: "",
};

const CustomAddress = (props) => {
  const {
    value = {},
    onChange,
    isLock = false,
    isReadOnly = false,
    disabled = false,
    action = "edit",
  } = props;
  const [open, setOpen] = useState(false);
  const [address, setAddress] = useState(defaultAddress);

  useEffect(() => {
    if (open) {
      if (action === "edit" && value && Object.keys(value)?.length) {
        setAddress(value);
      } else {
        setAddress(defaultAddress);
      }
    }
  }, [open]); // ✅ only re-run when dialog opens

  // useEffect(() => {
  //   if (value && Object.keys(value)?.length && action === "edit") {
  //     setAddress(value);
  //   } else {
  //     setAddress(defaultAddress);
  //   }
  // }, [value]);

  const selectedCountry = countryData?.find(
    (c) => c?.countryId === Number(address?.countryId)
  );
  const filteredStates = selectedCountry?.states || [];
  const selectedState = filteredStates?.find(
    (s) => s?.stateId === Number(address?.stateId)
  );
  const filteredCities = selectedState?.cities || [];

  const handleDialogToggle = () => {
    setOpen(!open);
  };

  const handleSave = () => {
    const finalData = {
      ...address,
      finalAddress: [
        address?.streetArea,
        address?.cityName,
        address?.stateName,
        address?.countryName,
        address?.pincode,
      ]
        .filter(Boolean)
        .join(", "),
    };
    if (onChange) onChange(finalData);
    setAddress(defaultAddress);
    setOpen(false);
  };

  return (
    <>
      {action === "add" ? (
        <Button
          variant="outlined"
          onClick={handleDialogToggle}
          disabled={disabled || isLock || isReadOnly}
        >
          Add Address
        </Button>
      ) : (
        <Tooltip title="Edit Address">
          <IconButton
            onClick={handleDialogToggle}
            disabled={disabled || isLock || isReadOnly}
            color="success"
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      )}

      <CustomDialog open={open} onClose={handleDialogToggle} maxWidth="sm">
        <DialogTitle fontWeight="bold">Fill the Address</DialogTitle>
        <Divider />
        <DialogContent>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Street/Area"
                  value={address?.streetArea}
                  onChange={(e) =>
                    setAddress((prev) => ({
                      ...prev,
                      streetArea: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Country</InputLabel>
                  <Select
                    value={address?.countryId}
                    label="Country"
                    onChange={(e) => {
                      const selected = countryData.find(
                        (c) => c.countryId === Number(e.target.value)
                      );
                      setAddress((prev) => ({
                        ...prev,
                        countryId: selected?.countryId,
                        countryName: selected?.name,
                        stateId: "",
                        stateName: "",
                        cityId: "",
                        cityName: "",
                      }));
                    }}
                  >
                    {countryData?.map((c) => (
                      <MenuItem key={c?.countryId} value={c?.countryId}>
                        {c?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth disabled={!address?.countryId}>
                  <InputLabel>State</InputLabel>
                  <Select
                    value={address?.stateId}
                    label="State"
                    onChange={(e) => {
                      const selected = filteredStates?.find(
                        (s) => s?.stateId === Number(e.target.value)
                      );
                      setAddress((prev) => ({
                        ...prev,
                        stateId: selected?.stateId,
                        stateName: selected?.stateName,
                        cityId: "",
                        cityName: "",
                      }));
                    }}
                  >
                    {filteredStates?.map((s) => (
                      <MenuItem key={s?.stateId} value={s?.stateId}>
                        {s?.stateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth disabled={!address?.stateId}>
                  <InputLabel>City</InputLabel>
                  <Select
                    value={address?.cityId}
                    label="City"
                    onChange={(e) => {
                      const selected = filteredCities?.find(
                        (c) => c?.cityId === Number(e.target.value)
                      );
                      setAddress((prev) => ({
                        ...prev,
                        cityId: selected?.cityId,
                        cityName: selected?.cityName,
                      }));
                    }}
                  >
                    {filteredCities?.map((c) => (
                      <MenuItem key={c?.cityId} value={c?.cityId}>
                        {c?.cityName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Pincode"
                  value={address?.pincode}
                  onChange={(e) =>
                    setAddress((prev) => ({
                      ...prev,
                      pincode: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </CustomDialog>
    </>
  );
};

export default CustomAddress;
